<template>
  <router-view></router-view>
</template>

<script>
  export default {
    // name: 'app'
  }
</script>


<style lang="stylus">
  @import '../node_modules/vuetify/src/stylus/main'
</style>

<style src="./css/main.scss" lang="scss"></style>

<!--
<style>
  @import '../node_modules/vuetify/dist/vuetify.min.css';
  @import './css/main.scss';
</style>
-->



// WEBPACK FOOTER //
// App.vue?4e139dd6